import React from 'react';
import ReactDOM from 'react-dom/client';
import WeddingWebsite from './WeddingWebsite';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<WeddingWebsite />);